import type { RouteLocationNormalized } from 'vue-router'
import queryClient from '@/plugins/query'
import { QUERY_KEYS } from '@/constants/query'

export default async (to: RouteLocationNormalized) => {
    switch (to.query.refetch) {
        case 'me':
            await queryClient.invalidateQueries({ queryKey: QUERY_KEYS.me })
            await queryClient.refetchQueries({ queryKey: QUERY_KEYS.me })
            break
    }
}
